/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import { ReactComponent as MicOffIcon } from '../images/icons/mic_off.svg';
import { ReactComponent as MicIcon } from '../images/icons/mic.svg';
import { ReactComponent as CameraIcon } from '../images/icons/camera.svg';
import { ReactComponent as CaneraOffIcon } from '../images/icons/camera_off.svg';
import { ReactComponent as ChatIcon } from '../images/icons/chat.svg';
import { ReactComponent as EndCallIcon } from '../images/icons/endcall.svg';
import { ReactComponent as VideoPreloader } from '../images/User_fill.svg';
import appStore from '../store';
import videoLoader from '../images/videoLoader.gif';
import { ReactComponent as Sound } from '../images/icons/sound.svg';

const MediaPlayer = (props) => {
  const {
    setShowChat, showChat, inScreenShare, videoActive, operatorOnMobile,
  } = props;
  const [showSelfCam, setShowSelfCam] = useState(false);
  const [showSelfCamContainer, setShowSelfCamContainer] = useState(false);
  const [operatorAudioActive, setOperatorAudioActive] = useState(true);
  const [isOperatorCameraOff, setIsOperatorCameraOff] = useState(false);

  const [operatorVideo, setOperatorVideo] = useState(videoActive);

  const [operator, setOperator] = useState(null);
  const [operatorSpeaking, setOperatorSpeaking] = useState(false);
  const [muted, setMuted] = useState(true);
  const ovdSession = appStore.useState((s) => s.ovdSession);
  const ovdSubscribers = appStore.useState((s) => s.ovdSubscribers);
  const ovdPublisher = appStore.useState((s) => s.ovdPublisher);
  const noVideoCanvas = appStore.useState((s) => s.noVideoCanvas);

  const SelfVideo = useRef(null);
  const IncVideo = useRef(null);
  // const [operatorVideoSize, setOperatorVideoSize] = useState({
  //   width: 1280,
  //   height: 720,
  // });

  const toggleChat = () => { setShowChat(!showChat); };

  const toogleSelfCam = async (e) => {
    e.stopPropagation();
    try {
      if (!ovdPublisher) return;
      if (!showSelfCam) {
        const userStream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });
        const videoTracks = userStream.getVideoTracks();
        const ourVideoTrack = videoTracks[0];
        ovdPublisher.replaceTrack(ourVideoTrack);
      } else {
        const noVideoMediaTrack = noVideoCanvas.captureStream(30).getVideoTracks()[0];
        ovdPublisher.replaceTrack(noVideoMediaTrack);
      }
      // ovdPublisher.publishVideo(!showSelfCam);
      setShowSelfCamContainer(!showSelfCamContainer);
      setShowSelfCam(!showSelfCam);
    } catch (err) {
      console.log('e === ', err);
    }
  };

  const toggleMicrophone = (e) => {
    e.stopPropagation();
    if (!ovdPublisher) return;
    ovdPublisher.publishAudio(!muted);
    setMuted(!muted);
  };

  const endCall = (e) => {
    e.stopPropagation();
    if (ovdSession) ovdSession.disconnect();
  };

  useEffect(() => {
    setOperatorVideo(videoActive);
  }, [videoActive]);

  useEffect(() => {
    console.log('TTTTT', IncVideo.current);
    if (ovdSubscribers.length > 0) {
      ovdSubscribers[0].addVideoElement(IncVideo.current);
      setOperator(ovdSubscribers[0]);
    }

    if (ovdPublisher) ovdPublisher.addVideoElement(SelfVideo.current);
  }, [ovdSubscribers, ovdPublisher]);

  useEffect(() => {
    if (operator) {
      console.log('SET OPERATOR EVENTS');
      operator.on('streamPlaying', () => {
        operator.on('streamPropertyChanged', (event) => {
          console.log('OPERATOR CHANGED', event);
          const { changedProperty, newValue } = event;
          switch (changedProperty) {
            case 'audioActive':
              setOperatorAudioActive(newValue);
              break;
            case 'videoActive':
              setOperatorVideo(newValue);
              break;
            default:
              break;
          }
        });
        operator.on('publisherStartSpeaking', (psevent) => {
          console.log('publisherStartSpeaking', psevent);
          setOperatorSpeaking(true);
        });
        operator.on('publisherStopSpeaking', (pstopevent) => {
          console.log('publisherStopSpeaking', pstopevent);
          setOperatorSpeaking(false);
        });
      });
    }
  }, [operator]);

  return (
    <>
      <div
        className={`media__player-remote ${(inScreenShare) ? 'media__player-remote-fullscreen' : ''}
        ${(operatorOnMobile) ? 'media__player-remote-mobileoperator' : ''}
        ${(operatorSpeaking ? 'media__player-operator-says' : '')}`}
        style={{ overflow: operatorOnMobile ? 'inherit' : 'hidden' }}
      >
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          poster={videoLoader}
          loop
          width="100%"
          disablePictureInPicture
          height="100%"
          ref={IncVideo}
          onClick={(e) => { e.preventDefault(); }}
          style={{ opacity: (inScreenShare || operatorVideo) ? 1 : 0, borderRadius: operatorOnMobile ? '20px' : '0px' }}
        />
        <div className="opertorVidoPreloader " style={{ opacity: (inScreenShare || operatorVideo) ? 0 : 1 }}>
          <VideoPreloader />
        </div>

        <div className="operator-action">
          {operatorAudioActive && <Sound className={`operator-action__icon-stroke ${operatorSpeaking ? 'operator-action__icon-stroke_active' : ''}`} />}
          {!operatorAudioActive && <MicOffIcon className="operator-action__icon_off" />}
          {isOperatorCameraOff && <CaneraOffIcon className="operator-action__icon_off" />}
        </div>

        <div className="media__player-controls">
          {/* <Timer type="Timer" active tick={1000} /> */}
          <button type="button" className="media__player-controls-button" onClick={toogleSelfCam}>
            {showSelfCam ? <CameraIcon /> : <CaneraOffIcon />}
          </button>
          <button type="button" className="media__player-controls-button" onClick={toggleMicrophone}>
            {muted ? <MicIcon /> : <MicOffIcon />}
          </button>
          <button type="button" className={`media__player-controls-button ${(showChat) && 'media__player-controls-button button-green'}`} onClick={toggleChat}>
            <ChatIcon />
          </button>
          <button type="button" className="media__player-controls-button button-red" onClick={endCall}>
            <EndCallIcon />
          </button>
        </div>

      </div>
      <Draggable bounds="parent">
        <div
          className="media__player-self"
          style={{
            opacity: showSelfCamContainer ? 1 : 0,
          }}
        >
          <video
            poster={videoLoader}
            controls={false}
            autoPlay
            disablePictureInPicture
            loop
            muted
            width="100%"
            height="100%"
            ref={SelfVideo}
            id="selfVideo"
            onClick={(e) => { e.preventDefault(); }}
          />
        </div>
      </Draggable>
    </>
  );
};

MediaPlayer.propTypes = {
  inScreenShare: PropTypes.bool.isRequired,
  showChat: PropTypes.bool.isRequired,
  operatorOnMobile: PropTypes.bool.isRequired,
  setShowChat: PropTypes.func.isRequired,
  videoActive: PropTypes.bool.isRequired,
};

export default MediaPlayer;
